module.exports = __webpack_public_path__ + "media/icons/icon-medal-second-6ef67c9a.svg";